<template>
  <div class="loading-overlay" v-if="isloading">
    <div class="loading-overlay-bg"></div>
    <div class="loading-content">
      <div id="lottie" style="position:relative;"></div>
      <div class="loading-text">Environmental safety testing...</div>
      <div class="loading-text1">Please wait 5-10 seconds</div>
    </div>
  </div>
</template>

<script>
import lottie from "lottie-web";
import AstronautJSON from "../../static/s1.json";

export default {
  name: "LoadingOverlay",
  props: {
    isloading: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      lottieOptions: {
        animationData: AstronautJSON,
        loop: true,
        autoplay: true,
        rendererSettings: {
          preserveAspectRatio: "xMidYMid meet"
        }
      }
    };
  },
  watch: {
    isloading(newVal, oldVal) {
      if (
        oldVal === true &&
        newVal === false &&
        document.getElementById("lottie")
      ) {
        lottie.destroy();
      }
    }
  },

  mounted() {
    this.svgFun();
  },

  methods: {
    svgFun() {
      let params = {
        container: document.getElementById("lottie"),
        renderer: "svg",
        loop: true,
        autoplay: true,
        animationData: this.lottieOptions.animationData
      };
      lottie.loadAnimation(params);
    }
  }
};
</script>

<style scoped>
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.loading-overlay-bg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  background-color: rgba(184, 249, 216, 0.5);
}

.loading-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.loading-text {
  color: #0a0a0a;
  font-weight: 600;
  font-size: 0.25rem;
  margin-top: 30px;
}

.loading-text1 {
  color: #5b5b5b;
  font-weight: 500;
  font-size: 0.20rem;
  margin-top: 12px;
}

#lottie {
  width: 300px;
  height: 300px;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/Loadingsaly.vue